// Action Types
export const FETCH_CPTS_REQUEST = 'FETCH_CPTS_REQUEST';
export const FETCH_CPTS_SUCCESS = 'FETCH_CPTS_SUCCESS';
export const FETCH_CPTS_FAILURE = 'FETCH_CPTS_FAILURE';

export const CREATE_CPT_REQUEST = 'CREATE_CPT_REQUEST';
export const CREATE_CPT_SUCCESS = 'CREATE_CPT_SUCCESS';
export const CREATE_CPT_FAILURE = 'CREATE_CPT_FAILURE';

export const UPDATE_CPT_REQUEST = 'UPDATE_CPT_REQUEST';
export const UPDATE_CPT_SUCCESS = 'UPDATE_CPT_SUCCESS';
export const UPDATE_CPT_FAILURE = 'UPDATE_CPT_FAILURE';

export const DELETE_CPT_REQUEST = 'DELETE_CPT_REQUEST';
export const DELETE_CPT_SUCCESS = 'DELETE_CPT_SUCCESS';
export const DELETE_CPT_FAILURE = 'DELETE_CPT_FAILURE';

export const FETCH_CPT_RULES_REQUEST = 'FETCH_CPT_RULES_REQUEST';
export const FETCH_CPT_RULES_SUCCESS = 'FETCH_CPT_RULES_SUCCESS';
export const FETCH_CPT_RULES_FAILURE = 'FETCH_CPT_RULES_FAILURE';

export const MAP_CPT_TO_RULE_REQUEST = 'MAP_CPT_TO_RULE_REQUEST';
export const MAP_CPT_TO_RULE_SUCCESS = 'MAP_CPT_TO_RULE_SUCCESS';
export const MAP_CPT_TO_RULE_FAILURE = 'MAP_CPT_TO_RULE_FAILURE';

export const DELETE_CPT_RULE_MAPPING_REQUEST = 'DELETE_CPT_RULE_MAPPING_REQUEST';
export const DELETE_CPT_RULE_MAPPING_SUCCESS = 'DELETE_CPT_RULE_MAPPING_SUCCESS';
export const DELETE_CPT_RULE_MAPPING_FAILURE = 'DELETE_CPT_RULE_MAPPING_FAILURE';

// Action Creators
export const fetchCptsRequest = ( options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_CPTS_REQUEST,
        payload: { page, limit, search },
        
      }; 
    }; 
export const fetchCptsSuccess = (cpts) => ({ type: FETCH_CPTS_SUCCESS, payload: cpts });
export const fetchCptsFailure = (error) => ({ type: FETCH_CPTS_FAILURE, payload: error });

export const createCptRequest = (data) => ({ type: CREATE_CPT_REQUEST, payload: data });
export const createCptSuccess = (cpt) => ({ type: CREATE_CPT_SUCCESS, payload: cpt });
export const createCptFailure = (error) => ({ type: CREATE_CPT_FAILURE, payload: error });

export const updateCptRequest = (id, data) => ({ type: UPDATE_CPT_REQUEST, payload: { id, data } });
export const updateCptSuccess = (cpt) => ({ type: UPDATE_CPT_SUCCESS, payload: cpt });
export const updateCptFailure = (error) => ({ type: UPDATE_CPT_FAILURE, payload: error });

export const deleteCptRequest = (id) => ({ type: DELETE_CPT_REQUEST, payload: id });
export const deleteCptSuccess = (id) => ({ type: DELETE_CPT_SUCCESS, payload: id });
export const deleteCptFailure = (error) => ({ type: DELETE_CPT_FAILURE, payload: error });

export const fetchCptRulesRequest = (projectId, cptId) => ({ type: FETCH_CPT_RULES_REQUEST, payload: { projectId, cptId } });
export const fetchCptRulesSuccess = (rules) => ({ type: FETCH_CPT_RULES_SUCCESS, payload: rules });
export const fetchCptRulesFailure = (error) => ({ type: FETCH_CPT_RULES_FAILURE, payload: error });

export const mapCptToRuleRequest = (projectId, cptId, ruleId) => ({ type: MAP_CPT_TO_RULE_REQUEST, payload: { projectId, cptId, ruleId } });
export const mapCptToRuleSuccess = () => ({ type: MAP_CPT_TO_RULE_SUCCESS });
export const mapCptToRuleFailure = (error) => ({ type: MAP_CPT_TO_RULE_FAILURE, payload: error });

export const deleteCptRuleMappingRequest = (projectId, cptId, ruleId) => ({ type: DELETE_CPT_RULE_MAPPING_REQUEST, payload: { projectId, cptId, ruleId } });
export const deleteCptRuleMappingSuccess = () => ({ type: DELETE_CPT_RULE_MAPPING_SUCCESS });
export const deleteCptRuleMappingFailure = (error) => ({ type: DELETE_CPT_RULE_MAPPING_FAILURE, payload: error });
